import { render } from "./tableLite.vue?vue&type=template&id=c584e48c&scoped=true"
import script from "./tableLite.vue?vue&type=script&lang=js"
export * from "./tableLite.vue?vue&type=script&lang=js"

import "./tableLite.vue?vue&type=style&index=0&id=c584e48c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c584e48c"]])

export default __exports__